import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@clerk/clerk-react';
import './LoginSuccess.css';

const StripeSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { getToken } = useAuth();
  const [statusMessage, setStatusMessage] = useState("Processing your subscription...");
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    const verifySubscription = async () => {
      try {
        // Get the session ID from the URL
        const urlParams = new URLSearchParams(location.search);
        const sessionId = urlParams.get('session_id');

        if (!sessionId) {
          throw new Error("No session ID found in the URL");
        }

        setStatusMessage("Verifying payment with Stripe...");

        // Get authentication token
        const token = await getToken();
        if (!token) {
          throw new Error("No authentication token available");
        }

        // Call API to verify and update subscription status
        const response = await fetch('/api/stripe/verify-subscription', {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ session_id: sessionId })
        });

        if (!response.ok) {
          const errorText = await response.text();
          throw new Error(`Failed to verify subscription: ${errorText}`);
        }

        setStatusMessage("Subscription activated successfully!");

        // Redirect to the chat interface after success
        setTimeout(() => {
          navigate('/home');
        }, 1500);
      } catch (error) {
        console.error("Error processing subscription:", error);
        setStatusMessage(`Error: ${error.message}`);
        setIsError(true);
      }
    };

    verifySubscription();
  }, [navigate, location.search, getToken]);

  return (
    <div className="login-success-container">
      <div className="login-success-main">
        <div className={isError ? "error" : "loading"}>
          <h1>{isError ? "Subscription Error" : "Payment Successful!"}</h1>
          <p>{statusMessage}</p>
          {!isError && <div className="spinner"></div>}
          {isError ? (
            <button
              onClick={() => navigate('/home')}
              className="continue-btn"
              style={{ marginTop: "20px" }}
            >
              Continue to Dashboard
            </button>
          ) : (
            <p>You will be redirected to the dashboard shortly.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default StripeSuccess;